/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThemeListFromJSON, ThemeListToJSON, } from './ThemeList';
/**
 * Check if a given object implements the BaseTheme interface.
 */
export function instanceOfBaseTheme(value) {
    return true;
}
export function BaseThemeFromJSON(json) {
    return BaseThemeFromJSONTyped(json, false);
}
export function BaseThemeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'publishedAt': json['publishedAt'] == null ? undefined : (new Date(json['publishedAt'])),
        'id': json['id'] == null ? undefined : json['id'],
        'themes': json['themes'] == null ? undefined : ThemeListFromJSON(json['themes']),
    };
}
export function BaseThemeToJSON(json) {
    return BaseThemeToJSONTyped(json, false);
}
export function BaseThemeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'documentId': value['documentId'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'publishedAt': value['publishedAt'] == null ? value['publishedAt'] : value['publishedAt'].toISOString(),
        'id': value['id'],
        'themes': ThemeListToJSON(value['themes']),
    };
}
